export default {
  subtotal: "Sous-total",
  pay: "Payer",
};
